import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import axios from 'core/libs/axios';

import themePropTypes from 'core/utils/prop-types/theme';

import withTheme from 'core/hocs/withTheme';


class CommentsCount extends PureComponent {
  static propTypes = {
    /** @ignore */
    theme: themePropTypes(`
      {
        controls: {
          comments: {
            const: {
              CountIcon,
            },
          },
        },
      }
    `),
    /**
     * ID топика.
     *
     * Должен совпадать с ID используемым при инициализации Рамблер комментариев.
     */
    xid: PropTypes.string.isRequired,
    /**
     * Отключение иконки
     */
    disableIcon: PropTypes.bool,
    /**
     * Возвращать 0 вместо null. Нужна в том случае, если значение будет отображаться в иконке
     */
    renderZero: PropTypes.bool,
  };

  static contextTypes = {
    ramblerCommentsAppId: PropTypes.number.isRequired,
  };

  state = {
    count: 0,
  };

  componentDidMount() {
    this._isMounted = true;
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.xid !== prevProps.xid) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setAtomicState = (...args) => {
    if (this._isMounted) {
      this.setState(...args);
    }
  };

  fetchData = () => {
    const { ramblerCommentsAppId } = this.context;

    if (ramblerCommentsAppId === 0) {
      this.setAtomicState({ count: 0 });
      return;
    }

    axios
      .get(`https://comments.rambler.ru/api/app/${ramblerCommentsAppId}/comments-count?xid=${this.props.xid}`)
      .then(response => response.data)
      .then(body => {
        this.setAtomicState({ count: body.xids[this.props.xid] || 0 });
      })
      .catch(() => {
        this.setAtomicState({ count: 0 });
      });
  };

  render() {
    const {
      theme,
      disableIcon,
      renderZero,
    } = this.props;

    if (this.state.count > 0) {
      const CountIcon = theme.controls.comments.const.CountIcon;

      return disableIcon ? this.state.count : <CountIcon value={this.state.count} />;
    }
    return renderZero ? 0 : null;
  }
}

const CommentsCountWithHOCs = withTheme(CommentsCount);
CommentsCountWithHOCs.displayName = 'CommentsCount';

export { CommentsCount as StorybookComponent };
export default CommentsCountWithHOCs;
